module.exports = __webpack_public_path__ + "img/sapphireAndRubin@2x.d880519.png";